import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { useMediaQuery } from "react-responsive"
import { useDispatch, useSelector } from "react-redux"
import { ProSidebar, SidebarHeader, SidebarContent, Menu, MenuItem } from "react-pro-sidebar"
import "react-pro-sidebar/dist/css/styles.css"
import { AdminRoutes as menuAdminRoutes, AsyncRoutes } from "../../routes/index"
import { useScope, useUser, SelectCompaniesContainer, useProjects } from "../SelectProjectCompanyContainer"

import { firebaseAuth } from "../../core/firebase"
import { BUILD_TIMESTAMP } from "../../core/utils/buildInfo"

import { LogoSideBar } from "../../components/Sidebar"
import CompanyMenu from "../../components/CompanyMenu"
import SelectCompanyContainer from "../SelectCompanyContainer"
import { UserMenu } from "../../components/Navigation"
import { logout } from "../LoginContainer"
import { VALE_USERS_EMAIL } from "../../core/vale/users"
import { platformDetails } from "../../core/utils/platformDetails"
import { setData } from "../../core/redux/app/Actions"
import { isMobile } from "react-device-detect"
import SendOfflineData from "../../components/SendOfflineDataAlert"
import { getPlatform } from "../../core/utils/platform"
import mixpanel from 'mixpanel-browser'; // Import mixpanel

const HeaderUser = ({ collapsed }) => {
  const user = useUser()
  const mobile = useMediaQuery({ query: "(max-width: 767px)" })

  return (
    <div className="sidebar-user-profile">
      {mobile ? (
        <UserMenu userName={user?.name} userImage={user?.image} collapsed={false} />
      ) : (
        <UserMenu userName={user?.name} userImage={user?.image} {...{ collapsed }} />
      )}
    </div>
  )
}

function SideBarContainer({ navigate, collapsed, setCollapsed, isChatOnly }) {
  const dispatch = useDispatch()
  const { pathname, state } = useLocation()
  const firebase_token = useSelector((state) => state.app?.user?.firebase_token)
  const userAdmin = useSelector((state) => state.app?.user?.user?.roles?.role)
  const userName = useSelector((state) => state.app?.user?.user?.name)
  const userEmail = useSelector((state) => state.app?.user?.user?.email)
  const [asyncRouteList, setAsyncRoutes] = useState([])
  const [companies, setCompanies] = useState([])
  const { scope, scopeType, projectConfig } = useScope()
  const [openCompanyMenu, setOpenCompanyMenu] = useState(false)
  const [openCompanyModal, setOpenCompanyModal] = useState(false)
  const companiesWithoutOrg = useSelector((state) => state.app.companiesWithoutOrg)
  const organizations = useSelector((state) => state.app.organizations)
  const chat = useSelector((state) => state.app.chat)
  const headerIsntNeeded = useSelector((state) => state.app.headerIsntNeeded)
  const offHeader = useSelector((state) => state.app.assistanceCategory)
  const mobile = useMediaQuery({ query: "(max-width: 767px)" })
  const { platformLogo, currentPlatform } = platformDetails(collapsed)
  useProjects()

  console.log({mobile})

  const platformNumbers = [1, 2, 3].includes(Number(process.env.REACT_APP_PLATFORM));

  useEffect(() => {
    if (scope?.id) {
      AsyncRoutes(scope?.id, scopeType).then((newRoutes) => setAsyncRoutes(newRoutes))
    }
  }, [scope?.id])

  useEffect(() => {
    if (firebase_token) {
      firebaseAuth()
        .signInWithCustomToken(firebase_token)
        .then((response) => {
          console.log("firebase logged", { response })
          // Track user access on session recovery with Mixpanel
          if (userEmail) {
            mixpanel.identify(userEmail);
          }
          mixpanel.people.set({
            "$name": userName,
            "$email": userEmail,
            "User Role": userAdmin
          });
          mixpanel.track("Session Recovered", {
            "Email": userEmail,
            "Role": userAdmin,
            "Timestamp": new Date().toISOString()
          });
        })
        .catch((e) => {
          console.log("firebase login error", { e })
        })
    }
  }, [firebase_token])

  useEffect(() => {
    if (asyncRouteList.length || menuAdminRoutes().length) {
      return
    } else {
      navigate("/")
    }
  }, [asyncRouteList, menuAdminRoutes()])

  useEffect(() => {
    if (isMobile && !platformNumbers) {
      dispatch(
        setData({
          chat: false,
        }),
      )
    }
  }, [pathname])

  const openModalProject = (data) => {
    setCompanies(data)
    setOpenCompanyModal(true)
  }
  
  // Se for chat isolado, retorna div vazia mas mantém a funcionalidade
  if (isChatOnly) {
    return <div style={{ display: 'none' }} />
  }

  return mobile && headerIsntNeeded && (chat?.id || offHeader) ? (
    <></>
  ) : (
    <ProSidebar
      collapsed={collapsed}
      className={`c-pro-sidebar-inner ${!collapsed ? "uncollapsed" : ""} ${mobile ? "logo-mobile" : ""}`}>
      <div onClick={() => setCollapsed(!collapsed)} className="c-pro-sidebar-header">
        <SidebarHeader>
          {!VALE_USERS_EMAIL.includes(userEmail) && (
            <>
              {mobile ? (
                <>
                  <div className="icon-menu" onClick={() => setCollapsed(!collapsed)}>
                    <i class={"fi fi-br-menu-burger"} />
                  </div>
                  <SendOfflineData/>
                  <LogoSideBar
                    logoImage={platformLogo}
                    currentPlatform={currentPlatform}
                    isMobile={true}
                  />
                </>
              ) : (
                <>
                <LogoSideBar logoImage={platformLogo} currentPlatform={currentPlatform} />
                </>
              )}
            </>
          )}
        </SidebarHeader>
      </div>
      <SelectCompanyContainer {...{ openCompanyMenu, setOpenCompanyMenu, collapsed }} />
      <SidebarContent>
        {(mobile && !collapsed) && (
          <div style={{ textAlign: "center", fontSize: '12px', padding: '8px 16px', opacity: 0.7 }}>
            Versão: {BUILD_TIMESTAMP}
          </div>
        )}
        <SelectCompaniesContainer
          data={companies}
          {...{ openCompanyModal, setOpenCompanyModal, setOpenCompanyMenu, openCompanyMenu, collapsed }}
        />
        {openCompanyMenu ? (
          <CompanyMenu {...{ organizations, companiesWithoutOrg, openModalProject }} />
        ) : (
          <div className="sidebar-menu">
            <span className="sidebar-menu__label">Menu</span>
            <Menu iconShape="square" className={"pro-menu-visible"}>
              {[...asyncRouteList, ...menuAdminRoutes()]
                .filter(
                  (item) =>
                    item &&
                    !item.hidden &&
                    ((item?.isRole && item.isRole.includes(userAdmin)) ||
                      (item?.restricted && item.restricted.includes(userEmail))  ||
                      (!item.isRole && !item.restricted)),
                )
                .filter(item => !projectConfig ? !item?.path?.includes('esm') : item)
                .map((item, index) => (
                  <MenuItem
                    title={item.name}
                    icon={item.icon}
                    key={index}
                    onClick={() => {
                      navigate(`${item.path}`, {
                        state: {
                          hiddenHeader: !item.name || item?.hiddenHeader || false,
                          name: item?.name,
                        },
                      })
                      if (mobile) {
                        setCollapsed((old) => !old)
                      }
                    }}
                    className={`${pathname == item.path ? "active" : "inactive"}`}
                    style={
                      VALE_USERS_EMAIL.includes(userEmail) && pathname == item.path
                        ? { backgroundColor: "#007e7a" }
                        : {}
                    }>
                    {item.name}
                  </MenuItem>
                ))}
              {mobile && (
                <MenuItem
                  title="Sair"
                  icon={<i className="fi fi-br-sign-out-alt" />}
                  onClick={() => logout()}
                  className="logout-menu-item"
                  style={{ color: '#ff6b35', borderTop: '1px solid #e0e0e0', marginTop: '10px' }}>
                  Sair
                </MenuItem>
              )}
            </Menu>
          </div>
        )}
        {!openCompanyMenu &&
          <HeaderUser {...{ collapsed }} />}
      </SidebarContent>
    </ProSidebar>
  )
}

export default SideBarContainer
